import { PreviewResponse } from "./types";

export type OperatorGroup = {
  operatorId: string | null;
  operatorName: string;
  storeCount: number;
  unitCount: number;
  stores: {
    store_id: string;
    store_name: string;
    region?: string;
    warnings: string[];
    formats: { id: string; name: string; canonical_name: string; count: number }[];
  }[];
};

export function buildOperatorGroups(preview: PreviewResponse): OperatorGroup[] {
  const groups = new Map<string, OperatorGroup>();
  
  for (const item of preview.items) {
    // Process each assignment (operator) for this store
    for (const assignment of item.assignments) {
      const opId = assignment.operator?.id ?? "unassigned";
      const opName = assignment.operator?.name ?? "Unassigned";
      
      if (!groups.has(opId)) {
        groups.set(opId, { 
          operatorId: assignment.operator?.id ?? null, 
          operatorName: opName, 
          storeCount: 0, 
          unitCount: 0, 
          stores: [] 
        });
      }
      
      const g = groups.get(opId)!;
      g.storeCount += 1;
      g.unitCount += assignment.unitCount;
      
      // Add this store to this operator's group
      g.stores.push({
        store_id: item.store_id,
        store_name: item.store_name,
        region: item.region,
        warnings: item.warnings,
        formats: assignment.formats.map(f => ({ id: f.id, name: f.name, canonical_name: f.canonical_name, count: f.count }))
      });
    }
  }
  
  return Array.from(groups.values())
    .sort((a, b) => a.operatorName.localeCompare(b.operatorName))
    .map(g => ({ 
      ...g, 
      stores: g.stores.sort((a, b) => a.store_name.localeCompare(b.store_name)) 
    }));
}
